import helpJewelryCare from "../../assets/content/help-jewelry-care.webp";
import helpOrderGift from "../../assets/content/help-order-gift.webp";
import helpRingBox from "../../assets/content/help-ring-box.webp";

export const supportTopics = [
  {
    title: "Track an order",
    text: "Review paid orders, totals, selected material, size, and quantity from your account.",
    linkLabel: "Open orders",
    to: "/UserPage/order-history",
  },
  {
    title: "Prepare checkout",
    text: "Create a shipping address, confirm tax, then choose Stripe or PayPal at payment.",
    linkLabel: "Go to cart",
    to: "/cart",
  },
  {
    title: "Choose the right piece",
    text: "Check materials, size, price, stock, and customer comments before adding to cart.",
    linkLabel: "Browse catalog",
    to: "/products",
  },
  {
    title: "Jewelry care",
    text: "Learn how to store and clean pieces so the finish stays protected after purchase.",
    linkLabel: "Read care tips",
    href: "#jewelry-care",
  },
];

export const guideCards = [
  {
    title: "Before you buy",
    eyebrow: "Product confidence",
    text: "Open the product page, review every available image, compare materials, and confirm stock before checkout.",
    image: helpRingBox,
    alt: "Ring displayed in a jewelry box",
  },
  {
    title: "After delivery",
    eyebrow: "Care and service",
    text: "Keep jewelry dry, store pieces separately, and use a soft cloth after wear. Delicate pieces should be checked professionally over time.",
    image: helpJewelryCare,
    alt: "Jeweler polishing a ring at a workbench",
  },
  {
    title: "Gift or personal order",
    eyebrow: "Order support",
    text: "Keep the order email, selected product, material, and size ready if support needs to identify a purchase.",
    image: helpOrderGift,
    alt: "Hands holding a jewelry gift box",
  },
];

export const careItems = [
  "Store jewelry separately to reduce scratches.",
  "Remove pieces before swimming, workouts, or cleaning.",
  "Use a soft cloth after wear to remove oils and moisture.",
  "Keep jewelry away from perfume, lotion, and harsh chemicals.",
];

export const faqAnchors: Record<string, string> = {
  "#ring-size-guide": "1",
  "#jewelry-care": "2",
};

export { helpRingBox };
